import React from 'react';

const NoPage = () => {
  return (
    <div>
      Ivalid URL
    </div>
  );
}

export default NoPage;
